import type { CustomSEOPage } from '@jane/bloom/types/schemas/roots/bloom/customSEO';

import { createMetaItem } from './createMetaVariables';

export function title(...parts: (string | undefined)[]) {
  return {
    title: parts.filter(Boolean).join(' | ') || 'Jane Premium',
  };
}

export function getMetaTitle(
  customSEOPage: CustomSEOPage,
  metaVariables: Record<string, string>,
  defaultTitle: string
) {
  return title(
    createMetaItem(
      !!customSEOPage?.title,
      metaVariables,
      customSEOPage?.title ?? '',
      defaultTitle
    )
  );
}
